import React from "react";
import { useFormikContext } from "formik";
import { Grid, Box } from "@mui/material";
// component
import { renderFormControl } from "components/FormManage/index";
// direct components
import "../../member.scss";
import { formInfo } from "../../helper";
import Summary from "../summary/summary";

const CreateForm = () => {
  const { values } = useFormikContext();
  const [openTag, setOpenTag] = React.useState(false);

  return (
    <Grid container>
      <Grid item xs={12} md={8}>
        <Box className="info_title">
          <h2>Form Information</h2>
          <p>Please complete the details below</p>
          <Box sx={{ mt: 5 }}>
            <Grid container spacing="3">
              {formInfo(openTag, setOpenTag, values)?.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  md={item?.grid ?? 12}
                  key={index}
                  sx={{ mb: 2 }}
                >
                  {renderFormControl(item)}
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Grid>

      <Grid item sm={12} md={4}>
        <Box className="class__summary">
          <Summary />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CreateForm;
